module.exports = __webpack_public_path__ + "static/cardboard-box-toy-figure-08b7a731decdf64864f6c5aac527a921.jpg";